var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('img',{ref:"imageRef",attrs:{"src":_vm.imageUrl},on:{"click":_vm.openViewer}})])}
var staticRenderFns = []

export { render, staticRenderFns }